import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import "../../Styles/Address.css";
import { FaMapMarkerAlt, FaPhoneAlt, FaHome, FaMapPin, FaEdit, FaPlus, FaBuilding, FaGlobe, FaTrash, FaCopy, FaStar } from 'react-icons/fa'; // Added more icons
import { ConfigContext } from '../../Context/ConfigContext';
import axios from 'axios';
import Swal from 'sweetalert2';

const CheckOutAddress = ({ setAddress }) => {
    const navigate = useNavigate();
    const { apiURL, apiHeaderJson } = useContext(ConfigContext);
    const [data, setData] = useState([]);

    const GetCustomerAddress = async () => {
        const headers = apiHeaderJson;
        try {
            const response = await axios.get(`${apiURL}Customers/GetCustomerAddress?limit=1&page=1`, { headers });

            if (response.data.data && response.data.data.length > 0) {
                const customerAddress = response.data.data[0];
                if (customerAddress.customer_address_id && customerAddress.default_address === 1) {
                    setData(customerAddress);
                    setAddress(customerAddress.customer_address_id);
                } else {
                    await Swal.fire({
                        title: "No Address Found",
                        text: "Please add your address and set a default address.",
                        icon: "warning",
                        confirmButtonColor: "#3085d6",
                        confirmButtonText: "Go to Address Page",
                    });
                    navigate("/MyAddress");
                }
            } else {
                await Swal.fire({
                    title: "No Address Found",
                    text: "Please add your address and set a default address.",
                    icon: "warning",
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "Go to Address Page",
                });
                navigate("/MyAddress");
            }
        } catch (error) {
            console.error("Error fetching customer address:", error);
            await Swal.fire({
                title: "Error",
                text: "Unable to retrieve address information. Please try again later.",
                icon: "error",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Retry"
            });
            GetCustomerAddress();
        }
    };

    const handleAddressClick = () => {
        navigate('/MyAddress');
    };

    const handleCreate = (e) => {
        e.stopPropagation();
        navigate("/AddressDetails");
    };

    const handleUpdate = (e) => {
        e.stopPropagation();
        if (data.customer_address_id) {
            navigate(`/AddressDetails/${data.customer_address_id}`);
        } else {
            Swal.fire({
                title: "Error",
                text: "No customer address found to update.",
                icon: "error",
                confirmButtonColor: "#3085d6",
            });
        }
    };

    useEffect(() => {
        GetCustomerAddress();
    }, []);

    return (
        <>
            <div className="card address-card" style={{ cursor: 'pointer' }}>
                <div className="card-bodys" onClick={handleAddressClick}>
                    <div className="address-icon">
                        <FaMapMarkerAlt size={24} color="#9D413C" />
                    </div>
                    <h5 className="card-title">{data.full_name}</h5>
                    <p className="card-text">
                        <FaPhoneAlt className="icon" /> {data.mobile_number}
                    </p>
                    <p className="card-text">
                        <FaHome className="icon" />  {data.flat_house_building}
                    </p>
                    <p className="card-text">
                        <FaBuilding className="icon" /> {data.town_city}, {data.state}, {data.pincode}
                    </p>
                    <p className="card-text">
                        <FaGlobe className="icon" /> {data.country_region}
                    </p>
                    <div className="action-icons">
                        <FaEdit className="icon action-icon" title="Update" onClick={handleUpdate} />
                        <FaPlus className="icon action-icon" title="Create" onClick={handleCreate} />
                    </div>
                </div>
            </div>
        </>
    );
}

export default CheckOutAddress;
